import {
  AlertDialog,
  AlertDialogAction,
  AlertDialogCancel,
  AlertDialogContent,
  AlertDialogDescription,
  AlertDialogFooter,
  AlertDialogHeader,
  AlertDialogTitle,
  AlertDialogTrigger,
} from '@/components/ui/alert-dialog'
import { Button } from '@/components/ui/button'

interface ResetVariantDialogProps {
  name: string
  isResetting: boolean
  onConfirm: () => void
}

/**
 * Reset is the only irreversible action in the sheet and it sits beside safe
 * ones, so it asks first.
 */
export function ResetVariantDialog({
  name,
  isResetting,
  onConfirm,
}: ResetVariantDialogProps) {
  return (
    <AlertDialog>
      <AlertDialogTrigger asChild>
        <Button
          type="button"
          variant="outline"
          className="mr-auto"
          disabled={isResetting}>
          Reset to primary
        </Button>
      </AlertDialogTrigger>
      <AlertDialogContent size="sm">
        <AlertDialogHeader>
          <AlertDialogTitle>Reset to the primary snippet?</AlertDialogTitle>
          <AlertDialogDescription>
            {`This deletes the duty's variant. The duty follows “${name}” again. This cannot be undone.`}
          </AlertDialogDescription>
        </AlertDialogHeader>
        <AlertDialogFooter>
          <AlertDialogCancel disabled={isResetting}>Cancel</AlertDialogCancel>
          <AlertDialogAction
            variant="destructive"
            disabled={isResetting}
            onClick={(event) => {
              // Radix closes on click; keep it up (disabled) while the DELETE
              // runs so a failure has a retry seat.
              event.preventDefault()
              onConfirm()
            }}>
            {isResetting ? 'Resetting…' : 'Reset to primary'}
          </AlertDialogAction>
        </AlertDialogFooter>
      </AlertDialogContent>
    </AlertDialog>
  )
}
